import { render, staticRenderFns } from "./SabitAlacakliList.vue?vue&type=template&id=61b1a8c5&scoped=true"
import script from "./SabitAlacakliList.vue?vue&type=script&lang=ts"
export * from "./SabitAlacakliList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b1a8c5",
  null
  
)

export default component.exports